<template>
  <div :class="componentClassName">
    <a-page-heading>アカウント情報確認・変更</a-page-heading>

    <m-section>
      <m-action-card :id="idName[1]" title="基本情報" icon="user" :header-border="true" :no-header-margin="true">
        <template #action>
          <a-button
            id="profileEditButton"
            :inline="true"
            variant="round"
            color="grey"
            size="small"
            icon="edit"
            label="編集"
            @click="gotoProfileEdit"
          />
        </template>
        <m-data-list
          id="profileInfo"
          variant="long"
          :data="[
            { label: 'ユーザーID', content: userID },
            { label: '登録者名', content: username },
            { label: '部署名', content: userData.departmentInfo },
          ]"
        />
      </m-action-card>

      <m-action-card
        v-if="canUpdatePassword"
        :id="idName[2]"
        class="t-profile-list__card-single-line"
        title="パスワード変更"
        icon="lock"
        :header-border="true"
      >
        <template #action>
          <a-button
            id="passwordEditButton"
            :inline="true"
            variant="round"
            color="grey"
            size="small"
            icon="edit"
            label="編集"
            @click="gotoPasswordEdit"
          />
        </template>
        <!--<m-data-list variant="long" :data="[{ label: '********', content: '' }]" />-->
      </m-action-card>

      <m-action-card
        :id="idName[3]"
        class="t-profile-list__card-single-line"
        title="マイク・スピーカー設定"
        icon="user-setting"
        :header-border="true"
      >
        <template #action>
          <a-button
            id="MicrophoneAndSpeakerEditButton"
            :inline="true"
            variant="round"
            color="grey"
            size="small"
            icon="edit"
            label="編集"
            @click="gotoMicrophoneAndSpeakerEdit"
          />
        </template>
        <m-data-list
          id="MicrophoneAndSpeakerInfo"
          variant="long"
          :data="[
            { label: 'マイク', content: microphoneName },
            { label: 'スピーカー', content: speakerName },
          ]"
        />
      </m-action-card>

      <m-action-card
        :id="idName[4]"
        class="t-profile-list__card-single-line"
        title="デスクトップ通知設定"
        icon="sound"
        :header-border="true"
      >
        <template #action>
          <a-button
            id="notificationEditButton"
            :inline="true"
            variant="round"
            color="grey"
            size="small"
            icon="edit"
            label="編集"
            @click="gotoNotificationEdit"
          />
        </template>
        <m-data-list
          id="notificationInfo"
          variant="long"
          :data="[{ label: 'デスクトップ通知ON／OFF', content: notificationFlagName }]"
        />
      </m-action-card>

      <!--<m-action-card
        class="t-profile-list__card-single-line"
        title="SMS認証用電話番号"
        icon="sms-phone"
        :header-border="true"
      >
        <template #action>
          <a-button
            :inline="true"
            variant="round"
            color="grey"
            size="small"
            icon="edit"
            label="編集"
            @click="gotoSmsEdit"
          />
        </template>
        <m-data-list variant="long" :data="[{ label: phoneNumber, content: '' }]" />
      </m-action-card>-->
    </m-section>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MActionCard from '@/components/molecules/action-card';
import AButton from '@/components/atoms/button';
import MSection from '@/components/molecules/section';
import MDataList from '@/components/molecules/data-list';

import { customRequest } from '@/common/customRequest.js';

export default {
  name: 't-profile-list',
  components: {
    APageHeading,
    MSection,
    MActionCard,
    AButton,
    MDataList,
  },
  mixins: [customRequest],
  props: {
    class: {
      type: String,
      default: '',
    },
    userID: {
      type: String,
      required: true,
    },
    username: {
      type: String,
      required: true,
    },
    companyID: {
      type: String,
      required: true,
    },
    phoneNumber: {
      type: String,
      default: '',
    },
    //handleProfileEditClick: {
    //  type: Function,
    //  default: () => {},
    //},
    //handlePasswordEditClick: {
    //  type: Function,
    //  default: () => {},
    //},
    //handlePhoneNumberEditClick: {
    //  type: Function,
    //  default: () => {},
    //},
    speakerDevices: {
      type: Array,
      default: new Array(0),
    },
    inputDevices: {
      type: Array,
      default: new Array(0),
    },
  },
  data() {
    return {
      userData: {
        userID: '',
        username: '',
        departmentInfo: '',
        authInfo: '',
        group: '',
        clientName: '',
        phone_number: '',
      },
      currentMicrophoneId: '',
      currentSpeakerId: '',
      canUpdatePassword: false,
      notificationFlagName: 'ON',
      idName: [],
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-profile-list');
      return `${baseClassName} ${this.class}`.trim();
    },
    //username() {
    //  return this.username.replace('_', ' ');
    //},
    microphoneName() {
      let name = '';
      for (const device of this.inputDevices) {
        if (device.value === this.currentMicrophoneId) {
          name = device.label.replace(/\(....:....\)/, '');
        } else if (device.value === 'default') {
          name = device.label.replace(/\(....:....\)/, '');
        }
      }
      return name;
    },
    speakerName() {
      let name = '';
      for (const device of this.speakerDevices) {
        if (device.value === this.currentSpeakerId) {
          name = device.label.replace(/\(....:....\)/, '');
        } else if (device.value === 'default') {
          name = device.label.replace(/\(....:....\)/, '');
        }
      }
      return name;
    },
  },
  mounted() {
    for (let i = 1; i <= 4; i++) {
      this.idName[i] = 'h4-profilelist' + i;
    }

    if (this.userID) {
      this.postRequest('/profile/getuserdata', { companyID: this.companyID, userID: this.userID }).then(e => {
        if (e.status === 'success') {
          this.userData = e.data;
          this.canUpdatePassword = !e.data.dAccountFlag;
        }
      });
      this.postRequest('/idmgmt/getNotificationFlag', { companyID: this.companyID, userID: this.userID }).then(e => {
        if (e.data) {
          if (e.data.flag === null || typeof e.data.flag === 'undefined') {
            this.notificationFlagName = 'ON';
          } else {
            if (e.data.flag === true) {
              this.notificationFlagName = 'ON';
            } else {
              this.notificationFlagName = 'OFF';
            }
          }
        }
      });
    }
    this.currentMicrophoneId = localStorage.getItem('microphoneId');
    this.currentSpeakerId = localStorage.getItem('speakerId');
  },
  methods: {
    gotoProfileEdit() {
      this.$router.push({ path: '/profileedituserinfo', query: { companyID: this.companyID, userID: this.userID } });
    },
    gotoPasswordEdit() {
      this.$router.push({ path: '/profileeditpassword' });
    },
    gotoSmsEdit(route) {
      this.$router.push({ path: '/profileeditsms', query: { companyID: this.companyID, userID: this.userID } });
    },
    gotoMicrophoneAndSpeakerEdit() {
      this.$router.push({
        path: '/profileeditmicrophoneandspeaker',
        query: { companyID: this.companyID, userID: this.userID },
      });
    },
    gotoSfSettingEdit() {
      this.$router.push({ path: '/profileeditsfsetting' });
    },
    gotoNotificationEdit() {
      this.$router.push({
        path: '/profileeditnotification',
        query: { companyID: this.companyID, userID: this.userID },
      });
    },
  },
};
</script>
